import { type Enum } from '@webapp/infrastructure/types/Enum'

export const FinancialAccountTypes = {
  AIRWALLEX_USD: 'AIRWALLEX_USD',
  AIRWALLEX_CAD: 'AIRWALLEX_CAD',
  AIRWALLEX_GBP: 'AIRWALLEX_GBP',
} as const

export type FinancialAccountTypeEnum = Enum<typeof FinancialAccountTypes>
